import { mapActions, mapGetters, mapMutations } from "vuex";
import { minLength, required } from "vuelidate/lib/validators";
import MainHeader from "@/components/header/index.vue";
import MainFooter from "@/components/footer/index.vue";
import Hidden from "@/components/hidden/index.vue";
import Basket from "@/components/basket/index.vue";
import Order from "@/components/order/index.vue";
import Breadcrumbs from "@/components/breadcrumbs/index.vue";
import mobileMenu from "@/components/mobile-menu/index.vue";
import { isMobile } from "@/helpers/variables";
import WarningPopUp from "@/components/popups/warning/index.vue";
import BranchesPopUp from "@/components/popups/choiceBranch/index.vue";

export default {
    name: "app",
    data() {
        return {
            formData: new FormData(),
            isMobileVersion: false,
            data: {
                phone: "",
                type: "need_consultation",
            },
            payload: {
                email: this.$route.query.email,
                token: this.$route.query.token,
            },
            showCookiesPopup: false,
            isShowPopup: false,
            isShowLeavePopup: true,
            validationErrors: {},
            localStorageClearVersionId: 9,
        };
    },
    validations: {
        data: {
            phone: {
                required,
                minLength: minLength(19),
            },
        },
    },
    components: {
        MainHeader,
        MainFooter,
        Hidden,
        Basket,
        Breadcrumbs,
        mobileMenu,
        Order,
        WarningPopUp,
        BranchesPopUp,
    },
    computed: {
        ...mapGetters({
            robots: "system/robots",
            globalLoader: "system/globalLoader",
            isAuthenticated: `auth/isAuthenticated`,
            showOrder: "basket/showOrder",
            allRequestsCompleted: "allRequestsCompleted",
        }),
        phoneErrors() {
            let error = [];
            if (!this.$v.data.phone.$dirty) {
                return error;
            }
            if (!this.$v.data.phone.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.data.phone.minLength) {
                error.push(this.$t("validationMin").replace(":count", 12));
            }
            if (this.validationErrors.phone) {
                this.validationErrors.phone.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
    },
    created() {
        this.checkAndClearLocalStorageOnInit();
        this.checkRobots();
        this.fetchMenu();
        this.fetchContacts();

        if (this.$route.params.lang) {
            document.querySelector("html").lang = this.$route.params.lang;
        }

        if (
            (!this.$route.query.hasOwnProperty("type") &&
                this.$route.query.hasOwnProperty("email") &&
                this.$route.query.hasOwnProperty("token")) ||
            this.$route.query.hasOwnProperty("phone")
        ) {
            this.changeSetNewPassword(true);
        }
        if (
            this.$route.query.hasOwnProperty("type") &&
            this.$route.query.hasOwnProperty("email") &&
            this.$route.query.hasOwnProperty("token")
        ) {
            this.loginByEmail(this.payload)
                .then(() => {
                    this.$router.push({ name: "profile" }).catch(() => {
                        console.log();
                    });
                })
                .catch(() => {});
        }

        if (this.$route.query.hasOwnProperty("payment")) {
            setTimeout(() => {
                this.$toasted.success(this.$t("successLiqPayPayment"));
            }, 1000);
        }
        if (this.isAuthenticated) {
            this.fetchUser();
            this.fetchFavouriteList();
        }
        if (!localStorage.getItem("favoritesList")) {
            localStorage.setItem("favoritesList", "[]");
        }
    },
    watch: {
        "$route.query"() {
            setTimeout(() => {
                if (
                    (!this.$route.query.hasOwnProperty("type") &&
                        this.$route.query.hasOwnProperty("email") &&
                        this.$route.query.hasOwnProperty("token")) ||
                    this.$route.query.hasOwnProperty("phone")
                ) {
                    this.changeSetNewPassword(true);
                }
                if (
                    this.$route.query.hasOwnProperty("type") &&
                    this.$route.query.hasOwnProperty("email") &&
                    this.$route.query.hasOwnProperty("token")
                ) {
                    this.loginByEmail(this.payload)
                        .then(() => {
                            this.$router.push({ name: "profile" }).catch(() => {
                                console.log();
                            });
                        })
                        .catch(() => {});
                }
                if (this.$route.query.hasOwnProperty("payment")) {
                    this.$toasted.success(this.$t("successLiqPayPayment"));
                }
            }, 300);
        },
        allRequestsCompleted: {
            immediate: true,
            handler(newVal) {
                if (newVal === true) {
                    window.prerenderReady = true;
                    console.log("Loaded: ", window.prerenderReady);
                }
            },
        },
    },
    methods: {
        ...mapMutations({
            changeSetNewPassword: `auth/CHANGE_POPUP_SET_NEW_PASSWORD`,
            changeShowNotLeavePopup: "setting/SHOW_NOT_LEAVE_POPUP",
            changeShowNeedConsultation: "setting/SHOW_NEED_CONSULTATION",
        }),
        ...mapActions({
            fetchMenu: `setting/GET_CATEGORIES_MENU`,
            fetchContacts: `contacts/GET_CONTACTS`,
            fetchFavouriteList: `favorites/GET_FAVORITES_LIST`,
            fetchUser: `profile/FETCH_USER_DATA`,
            loginByEmail: "auth/LOGIN_BY_TOKEN",
            fetchDataFromPopup: "articles/SEND_DATA_FROM_POPUPS",
            checkRobots: "system/CHECK_ROBOTS",
        }),
        clearLocalStorage() {
            const keysToPreserve = ['user_token', '_ls_clear', 'agreeCookies'];
            Object.keys(localStorage).forEach(key => {
                if(!keysToPreserve.includes(key)) {
                    localStorage.removeItem(key);
                }
            });
        },
        checkAndClearLocalStorageOnInit() {
            if(localStorage.getItem('_ls_clear') !== this.localStorageClearVersionId.toString()) {
                this.clearLocalStorage();
                localStorage.setItem('_ls_clear', this.localStorageClearVersionId.toString());
            }
        },
        onResize() {
            this.isMobileVersion = window.innerWidth < 600;
        },
        hidePopUp() {
            this.isShowPopup = false;
        },
        showPopup() {
            let brunch = localStorage.getItem("branchId");

            if (this.isShowLeavePopup && brunch) {
                this.changeShowNotLeavePopup(true);
                this.isShowLeavePopup = false;
            }
        },
        isShoeCookiesPopup(status) {
            if (status === "agree") {
                localStorage.setItem("agreeCookies", "agree");
                this.showCookiesPopup = false;
                this.isShowPopup = true;
            } else {
                this.showCookiesPopup = false;
                this.isShowPopup = true;
            }
        },
        async showNotLeavePopup() {
            await setTimeout(() => {
                this.changeShowNotLeavePopup(true);
            }, 180000)
        },
        submitPopup() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                let data = {};
                data.phone = this.data.phone;
                data.type = "need_consultation";
                this.fetchDataFromPopup(data).then(() => {
                    this.isShowPopup = false;
                });
                // this.fastBuy(obj)
                //     .then(() => {
                //       this.$toasted.success(this.$t('successCreateFastBuy'));
                //       this.changeFastBuy(false, {
                //         show: false,
                //       });
                //     }).catch(error => {
                //   if (error.response.status === 418) {
                //     this.$toasted.error(error.response.data.data.error.message);
                //   }
                //   if (error.response.status === 422) {
                //     this.$toasted.error(error.response.data.message);
                //   }
                // });
            }
        },
    },

    async mounted() {
        if (localStorage.getItem("agreeCookies")) {
            setTimeout(() => {
                this.isShowPopup = true;
            }, 20000);
        } else {
            setTimeout(() => {
                this.showCookiesPopup = true;
            }, 2000);
        }

        // let body = this.$refs.body;
        // body.addEventListener("mouseleave", this.showPopup);
        this.$nextTick(() => {
            this.onResize();
            window.addEventListener("resize", this.onResize, { passive: true });
        });
        if (!isMobile.any()) {
            document.querySelector("body").classList.add("hover");
        }

        await this.showNotLeavePopup();
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },
    destroyed() {},
};
